import { useMediaQuery } from '@hopskipdrive/react-components';
import { differenceInHours, intervalToDuration } from 'date-fns';
import pluralize from 'pluralize';

import { variables } from '../../components/variables';

export const estimatedTimeFromNowWithin24Hours = (futureDateTime) => {
  const startsAt = new Date(futureDateTime);
  const interval = intervalToDuration({ start: startsAt, end: new Date() });
  const formattedInterval = [
    interval.hours ? `${interval.hours} hr` : undefined,
    interval.minutes ? `${interval.minutes} min` : undefined,
  ].filter((str) => str);
  const hoursDifference = differenceInHours(startsAt, new Date());
  const is24HourInPastOrFuture = hoursDifference < 24 && hoursDifference > -24;
  const isDateInFuture = startsAt > new Date();

  return is24HourInPastOrFuture && ` (${formattedInterval.join(' & ')}${isDateInFuture ? ' from now' : ' ago'})`;
};

export const estimatedTimeFromNowWithin24HoursSlim = (futureDateTime) => {
  const startsAt = new Date(futureDateTime);
  const interval = intervalToDuration({ start: startsAt, end: new Date() });
  const formattedInterval = [
    interval.hours ? pluralize('hour', interval.hours, true) : undefined,
    interval.minutes ? pluralize('minute', interval.minutes, true) : undefined,
  ].filter((str) => str);
  const hoursDifference = differenceInHours(startsAt, new Date());
  const is24HourInPastOrFuture = hoursDifference < 24 && hoursDifference > -24;

  return is24HourInPastOrFuture && formattedInterval ? `(in ${formattedInterval.join(' & ')})` : '';
};

export const estimatedTimeFromNow = (futureDateTime) => {
  const startsAt = new Date(futureDateTime);
  const interval = intervalToDuration({ start: startsAt, end: new Date() });
  const hasDaysOrMonthsOrYearsDifference =
    (interval.days ?? 0) > 0 || (interval.months ?? 0) > 0 || (interval.years ?? 0) > 0;

  const formattedInterval = [
    !hasDaysOrMonthsOrYearsDifference && interval.hours ? `${interval.hours} hr` : undefined,
    !hasDaysOrMonthsOrYearsDifference && interval.minutes ? `${interval.minutes} min` : undefined,
    interval.days && !interval.months && !interval.years ? pluralize('day', interval.days, true) : undefined,
    interval.years ? pluralize('year', interval.years, true) : undefined,
    interval.months ? pluralize('month', interval.months, true) : undefined,
  ].filter((str) => str);
  const isDateInFuture = startsAt > new Date();

  return `(${formattedInterval.join(' & ')}${isDateInFuture ? ' from now' : ' ago'})`;
};

export const useIsMobileOrTablet = () => {
  return useMediaQuery({ maxWidth: variables.breakpoints.desktop - 1 });
};
